const v = 8;
const OFFSETS = {
  left: [-v, 0],
  right: [v, 0],
  top: [0, -v],
  bottom: [0, v]
};
const CLS_PREFIX = 'hbl-tooltip';

export { CLS_PREFIX, OFFSETS };
